import { pathOr } from "ramda";
import React, { useState } from "react";
import styled from "styled-components";
import { Tooltip, Button } from "antd";

import ReserveDisabledIcon from "views/resources/icons/reserveDisabledIcon.svg";
import ReserveIcon from "views/resources/icons/reserveIcon.svg";
import TicketDisabledIcon from "views/resources/icons/ticketDisabledIcon.svg";
import TicketIcon from "views/resources/icons/ticketIcon.svg";
import getIconStatus from "lib/helpers/getIconsStatus";

const Icon = styled.img`
	margin-right: 6px;
	width: 24px;
`;

const Container = styled.div`
	display: flex;
	z-index: 998;
	top: 15px;
	right: 10px;
	position: ${(props) => (props.position ? "absolute" : "static")};
	padding-left: ${(props) => (props.position ? "20px" : "auto")};
	@media (max-width: 768px) {
		top: 10px;
		right: 10px;
	}
`;

export const IconTags = ({ office = {}, setPosition, line }) => {
	const position = !!setPosition;

	const { options } = office;
	const disabled = pathOr(false, ["office_disable", "active"], options);

	const attentionsConfig = pathOr(null, ["attention_type"], options);

	const officeTicketOption =
		attentionsConfig &&
		attentionsConfig.tickets !== null &&
		attentionsConfig.tickets !== undefined
			? attentionsConfig.tickets
			: null;
	const officeReserveOption =
		attentionsConfig &&
		attentionsConfig.reservations !== null &&
		attentionsConfig.reservations !== undefined
			? attentionsConfig.reservations
			: null;

	const LineTicketOption = pathOr(
		false,
		["meta", "disabled_virtual_tickets"],
		line
	);
	const LineReserveOption = pathOr(
		false,
		["meta", "disabled_reserves"],
		line
	);

	const [iconsStatus, setIconsStatus] = useState({
		tickets: getIconStatus(officeTicketOption, LineTicketOption),
		reserves: getIconStatus(officeReserveOption, LineReserveOption),
	});

	if (disabled) {
		return (
			<Container position={position}>
				<Icon src={TicketDisabledIcon} />
				<Icon src={ReserveDisabledIcon} />
			</Container>
		);
	}

	return (
		<Container position={position}>
			{iconsStatus.tickets ? (
				<Tooltip placement="top" title="Tickets disponibles">
					<Icon
						src={TicketIcon}
						style={{ minWidth: 24, maxWidth: 24 }}
					/>
				</Tooltip>
			) : (
				<Tooltip placement="top" title="Tickets no disponibles">
					<Icon
						src={TicketDisabledIcon}
						style={{ minWidth: 24, maxWidth: 24 }}
					/>
				</Tooltip>
			)}
			{iconsStatus.reserves ? (
				<Tooltip placement="top" title="Reservas disponibles">
					<Icon
						src={ReserveIcon}
						style={{ minWidth: 24, maxWidth: 24 }}
					/>
				</Tooltip>
			) : (
				<Tooltip placement="top" title="Reservas no disponibles">
					<Icon
						src={ReserveDisabledIcon}
						style={{ minWidth: 24, maxWidth: 24 }}
					/>
				</Tooltip>
			)}
		</Container>
	);
};
